import { sign } from "chart.js/helpers";
//https://d2c4d2pjttf9c7.cloudfront.net/elmaam-service/swagger-ui/index.html#
export const API = {
    login : "auth/login",

    listCommunication : "api/communications",
    saveCommunication:"api/communications/create",
    editCommunication:"api/communications/edit",
    deleteCommunication : "api/communications/delete",
    assignCommunication:"api/communications/assign",
    assignCommunicationToUser : "api/communications/assign",
    unassignCommunicationToUser : "api/communications/assign/remove",
    unassignCommunication : "api/communications/remove",
    updateCommunicationStatus : "api/communications/status",

    listAssessment : "api/assessments",
    saveAssessment : "api/assessments/create",
    editAssessment : "api/assessments/edit",
    deleteAssessment : "api/assessments/delete",
    assignAssessment:"api/assessments/assign",
    unassignAssessment:"api/assessments/assign/remove",
    addAssessmentQuestion : "api/assessments/questions/add/1",
    addAssessmentQuestion2 : "api/assessments/questions/add/2",
    addAssessmentQuestion3 : "api/assessments/questions/add/3",
    editAssessmentQuestion : "api/assessments/questions/edit/1",
    editAssessmentQuestion2 : "api/assessments/questions/edit/2",
    editAssessmentQuestion3 : "api/assessments/questions/edit/3",
    deleteAssessmentQuestion :"api/assessments/questions/delete",
    updateTestStatus : "api/assessments/submit",
    reviewAssessment : "api/assessments/review",
    evaluateAssessment : "api/assessments/status",

    addUser : "api/users/create",
    listUser : "api/users",
    deleteUser : "api/users/delete",
    getUserDetail : "api/users/",
    editUser : "api/users/edit",
    passwordreset:"api/users/password/change",


    listActivity : "api/",

    saveTraining : "api/training/create",
    listTraining : "api/trainings",
    editTraining :'api/training/edit',
    
    assignTrainingToUser : "api/training/assign",
    unAssignTraining : "api/training/assign/remove",
    addTrainingQuestion : "api/training/data/add",
    deleteTrainingQuestion : "api/training/data/delete",
    deleteTraining : 'api/training/delete',
    getTrainingDetail : 'api/training/',
    updateTrainingStatus : 'api/training/status',

    adminOverview : "api/reports/basic",
    getUserMasterData : "api/masterdata",
    getReportees : "api/users/reportees",
    getReportByTask : "api/reports/task",
    getReportByUser : "api/reports/user",
    getTaskFile : "elmaam-service/api/reports/task/file",
    getUserFile : "elmaam-service/api/reports/user/file",

    getDepartmentDataReport:"api/reports/statistics/status",

    getReportByProject : "api/reports/project",
    getReportByLevel : "api/reports/level",
    getProjectFile : "elmaam-service/api/reports/project/file",
    getLevelkFile :  "elmaam-service/api/reports/level/file",

    checkIfAttemptAllowed : "api/assessments/checkIfAttemptAllowed",

    signup : "api/tenant/create",
    approveSignup : "api/tenant/approve",
    getTenantDetail : "api/tenant",
    createMasterData : "api/masterdata/create",
    getMasterData : "api/masterdata",
    departmentData: "api/groups/create",
    getDepartmentData: "api/groups",

    submitIdea: "api/idea/submit",
    myIdeas: "api/idea/myIdeas",
    ideaList : "api/idea/list",
    assignIdea : "api/idea/assign",
    updateIdeaStatus : "api/idea/status",
    forwardIdea : "api/idea/forward",
    submitForReview : "api/idea/submitForReview"



}